<template>
    <div>
        <div class="h-100 bg-white bd-radius-5">
            <b-card-body>
                <b-card-text class="p-0 scroll-bar-pop card-tab">
                    <div class="row justify-content-center pb-3">
                        <div class="col-12">
                            <h3 
                                v-html="stepTitle" 
                                class="cursor-pointer d-flex align-items-center text-info" 
                                @click="setAction()"
                            >
                            </h3>
                        </div>
                    </div>
                    <template v-if="tabCourier.subStep === getStepPage.SUB_STEP_CREATEBOOKING">
                        <FormLineBooking 
                            :showCart="showCart"
                            :booking="booking"
                            :sender="sender"
                            :dropoffLine="dropoffLine"
                            @openModalAlert="openModalAlert"
                        />
                        <FormLineParcel
                            v-if="booking.bookingItems.length > 0"
                            ref="lineParcel"
                            :booking="booking"
                            :listSize="listSize"
                            :showCart="showCart"
                        />
                    </template>
                    <template v-if="tabCourier.subStep === getStepPage.SUB_STEP_CHECKPRICE">
                        <BookingCheckPrice 
                            :noteToShop="booking.noteToShop"
                            :courierList="courierList"
                            :isSelected="booking.isSelected" 
                        />
                    </template>
                </b-card-text>
                <div class="row text-right" v-if="tabCourier.subStep === getStepPage.SUB_STEP_CREATEBOOKING">
                    <div class="col-12">
                        <b-button
                            :disabled="booking.bookingItems.length === 0 || isLoading"
                            variant="success" 
                            class="w-25" 
                            @click="validateBooking()"
                        >
                            <i class="fas fa-circle-notch fa-spin" v-if="isLoading"></i>
                            ยืนยัน
                        </b-button>
                    </div>
                </div>
                <div class="row text-center" v-if="tabCourier.subStep === getStepPage.SUB_STEP_CHECKPRICE">
                    <div class="col-6">
                        <b-button
                            variant="default" 
                            class="w-50" 
                            @click="changeSubStep(getStepPage.SUB_STEP_CREATEBOOKING)"
                        >
                            ย้อนกลับ
                        </b-button>
                    </div>
                    <div class="col-6">
                        <b-button
                            variant="success" 
                            class="w-50" 
                            @click="saveBooking()"
                        >
                            ยืนยัน
                        </b-button>
                    </div>
                </div>
            </b-card-body>
        </div>
        <ModalAlert
            :alert="alert"
        />
    </div>
</template>

<script>
import { 
    getStepPage,
    groupBy
} from "@/plugins/posHelper.js";
import FormLineBooking from '@/components/custom/pos/form/FormLineBooking';
import FormLineParcel from '@/components/custom/pos/form/FormLineParcel';
import BookingCheckPrice from '@/components/custom/pos/BookingCheckPrice';
import ModalAlert from '@/components/Modals/ModalAlert'
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import { getCourierCheckPriceV2 , getIcon } from "@/axios/pos.js";
import {
  required,
} from "vuelidate/lib/validators";

export default {
    props:{
        tabCourier: Object,
        listSize: Object,
        showCart: String,
        sender: Object,
        cart: Array,
        couriers: Array,
        insurance: Object,
        count: Number,
        dropoffLine: Object
    },
    components:{
        BookingCheckPrice,
        FormLineBooking,
        FormLineParcel,
        ModalAlert
    },
    data:() => ({
        getStepPage,
        booking: {
            isLoading: false,
            bookingNo: '',
            courierCode: 'DEFAULT',
            createdAt: '',
            totalShipment: 0,
            bookingItems: [],
            noteToShop: '',
            isSelected: {
                courierId: null,
                list: {} 
            }
        },
        courierList: [],
        alert:{
            show : false,
            icon : "",
            emphasize : "",
        },
        isLoading: false
    }),
    methods:{
        changeStepPage(step){
            this.tabCourier.step = step
        },
        changeSubStep(step){
            this.tabCourier.subStep = step
        },
        validateBooking(){
            if( this.booking.bookingNo.length < 6 || this.isLoading ){
                return false
            }
            
            let lineParcel = this.$refs.lineParcel

            for (let [index, val] of this.booking.bookingItems.entries()) {
                lineParcel.$v.$touch();
                lineParcel.$refs.dimensionParcel[index].$v.dimension.$touch();

                if( lineParcel.$v.booking.bookingItems.$each[index].parcel.weight.$invalid ){
                    this.$nextTick(() => lineParcel.$refs.focusWeight[index].focus())
                    return false
                }

                if( lineParcel.$refs.dimensionParcel[index].$v.dimension.$invalid ){
                    this.$nextTick(() => lineParcel.$refs.dimensionParcel[index].$refs.focusWidth.focus())
                    return false
                }  

                if( lineParcel.validateWeight[index].checkWeight.status 
                    || lineParcel.$refs.dimensionParcel[index].validateDimension.checkDimension.status 
                ){
                    return false
                }

            }          
            
            this.confirmBooking()
        },
        confirmBooking(){
            this.isLoading = true;
            getCourierCheckPriceV2(this.booking.bookingItems).then( async (resCourier) => {
                this.courierList = resCourier;
                console.log(this.courierList)
                // เผื่อ sort ที่ front-end
                this.courierList = Object.values(resCourier).sort( (a,b) => { 
                    return (a.shipment[0].status===false)-(b.shipment[0].status===false) 
                    || (Number(a.total_price)===0)-(Number(b.total_price)===0) 
                    || Number(a.total_price) - Number(b.total_price)
                })

                Object.values(this.courierList).forEach( async(courier , key) => {
                    courier.shipment.forEach( async(item , index) => {
                        this.$set(Object.values(this.courierList)[key]['shipment'][index], 'src' , 'img/brand/load-error.svg')
                        await getIcon( item.courier_icon ).then( res => {
                            this.$set(Object.values(this.courierList)[key]['shipment'][index], 'src' , res)
                        })
                    })
                });

                this.changeSubStep(getStepPage.SUB_STEP_CHECKPRICE)
                this.isLoading = false;
            }).catch(e => {
                showErrorModal(e)
                this.isLoading = false;
            });
        },
        saveBooking(){
            let count = this.count
            let _booking = [];
            this.booking.isSelected.list.shipment.forEach( (item, i) => {
                [item.to.district, item.to.state] = [item.to.state, item.to.district];
                [item.from.district, item.from.state] = [item.from.state, item.from.district];
                _booking[i] = {...item}
                _booking[i].error = {
                    status: false,
                    data: [],
                    msg: null
                }
                _booking[i].ratetype = item.courier_rate_type
                _booking[i].name = item.courier_name
                _booking[i].key = item.courier_code
                _booking[i].refer_id = item.courier_id
                _booking[i].price = +item.price
                _booking[i].fuel_surcharge = item.fuel_surcharge
                _booking[i].cross_price = 0;
                _booking[i].rate_remote_area = item.remote_area
                _booking[i].check = count++;
                _booking[i].courier = this.couriers.find(courier => courier.id === item.courier_id)
                _booking[i].insurance = this.insurance
            })

            this.cart.push(..._booking);
            this.$emit('addDraftStorage')
            this.$emit('checkDisableCardCourier')
            this.changeSubStep(getStepPage.SUB_STEP_CREATEBOOKING);
            this.changeStepPage(getStepPage.STEP_COURIER)
        },
        openModalAlert(icon , emphasize){
            this.alert.show = true;
            this.alert.icon = icon; //'<i class="fas fa-exclamation-triangle text-yellow fa-5x"></i>'
            this.alert.emphasize = emphasize; //'<span>ขออภัย! พบข้อผิดพลาดในการสแกน QR Code <br> กรุณาลองใหม่อีกครั้ง</span>'
        },
        resetForm(){
            this.booking = {
                isLoading: false,
                bookingNo: '',
                courierCode: 'DEFAULT',
                createdAt: '',
                totalShipment: 0,
                bookingItems: [],
                isSelected: {
                    courierId: null,
                    list: {} 
                }
            }
            this.courierList = []
            this.isLoading = false
        },
        setAction(){
            this.resetForm();
            this.changeSubStep(getStepPage.SUB_STEP_CREATEBOOKING);
            this.changeStepPage(getStepPage.STEP_COURIER);
            this.$emit('settingCartSlide' , 'non-slide')
        },
    },
    computed:{
        stepTitle(){
            let text = '';
                text = '<i class="fas fa-angle-left pr-1"></i> กลับสู่หน้าหลัก';
            return text;
        }
    }
}
</script>